<template>
	<div class="data-detail">
		<PageHeaderLayout :isBack="true">
			<ApeTable v-permission:money_list ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus"
				:pagingData="pagingData" highlight-current-row @switchPaging="switchPaging">
			</ApeTable>
			
		</PageHeaderLayout>
	</div>

</template>

<script>
	import PageHeaderLayout from '@/layouts/PageHeaderLayout'
	import ApeTable from "@/components/ApeTable";
	export default {
		components: {
			PageHeaderLayout,
			ApeTable
		},
		data() {
			return {
				loadingStaus: false,
				searchCondition: {
					company_id: '',
					type: '',
					company_type: '',
				},
				// 分页信息
				pagingData: {
					is_show: true,
					layout: "total, sizes, prev, pager, next, jumper",
					total: 0,
				},
				dataList: [],

				columns: [{
						title: "上次登陆时间",
						value: "last_login_time",
						header_align: "center",
						align: "center",
					},{
						title: "登录次数",
						value: "login_num",
						header_align: "center",
						align: "center",
					},
					{
						title: "充值金额",
						value: "recharge_money",
						header_align: "center",
						align: "center",
					},
					{
						title: "新建项目数量",
						value: [{
								width: '50',
								label: 'BPO:',
								value: 'hr_project_bpo_add_num'
							},
							{
								width: '50',
								label: 'RPO:',
								value: 'hr_project_rpo_add_num'
							},
							{
								width: '50',
								label: '灵工:',
								value: 'hr_project_lg_add_num'
							},
						],
					},
					{
						title: "新建总项目数",
						value: "hr_project_add_num",
						header_align: "center",
						align: "center",
					},
					{
						title: "新建招聘信息",
						value: "recruit_task_add_num",
						header_align: "center",
						align: "center",
					},
					{
						title: "新增招聘报名人员",
						value: "employee_enroll_add_num",
						header_align: "center",
						align: "center",
					},
					{
						title: "新增入库人才",
						value: "employee_add_num",
						header_align: "center",
						align: "center",
					},
					{
						title: "新增考勤组",
						value: "attendance_add_num",
						header_align: "center",
						align: "center",
					},
					
				],
			}
		},
		methods: {
			// 重置分页
			async resetPage() {
				this.$refs.apeTable.currentPage = 1;
			},
			// 切换页码操作
			async switchPaging() {
				this.init();
			},
			//查询	
			searchButton() {
				this.resetPage()
				this.init()
			},
			//获取列表
			async init() {
				let pagingInfo = this.$refs['apeTable']?.getPagingInfo() || {
					page_size: 10,
					current_page: 1
				}
				this.loadingStaus = true;
				let res = await this.$api.getstatisticsInfo({
					...pagingInfo,
					...this.searchCondition
				})
				this.dataList = res.items || []
				this.pagingData.total = res.total
				this.loadingStaus = false;
			}
		},

		created() {
			this.searchCondition.company_id = this.$route.params.id || ''
			this.searchCondition.type = this.$route.query.type.slice(2) || 'day'
			this.searchCondition.company_type = this.$route.query.company_type || '1'
			console.log(this.$route)

			//获取详情
			this.init()

		},
		mounted() {
		},
	}
</script>

<style lang="scss" scoped>
	.oem-main {
		background-color: white;
		padding: 20px 0;
		border-radius: 8px;
		box-sizing: border-box;
	}
</style>
